<template>
  <el-popover
    v-model="dialogValue"
    :visible-arrow="false"
    :width="440"
    trigger="manual"
    popper-class="missing-font-modal"
    placement="bottom-start"
  >
    <div class="missing-font-wrap">
      <div class="missing-font-wrap-title">
        <span>字体确认</span>
        <i class="el-icon-close" @click="onCancel"></i>
      </div>
      <div class="missing-font-wrap-cont">
        <div class="missing-font-wrap-cont-tip">作品存在缺失字体，已为你只能替换，你可在此替换或点击确认以继续使用 </div>
        <ul class="missing-font-wrap-cont-list">
          <div>
            <div>缺失字体</div>
            <div>替换字体</div>
          </div>
          <li class="missing-font-wrap-cont-list-li" v-for="(item, index) in dataList" :key="index">
            <div>
              <zhitu-icon icon="icon_position" class="icon-size24" @click.native.stop="handleFocusLayer(item.fontName)"/>
              <span class="c-ellipsis" :title="item.fontName">{{ item.fontName }}</span>
            </div>
            <zhitu-icon icon="a-icon_rightarrow" class="icon-size24"/>
            <div>
              <el-select
                v-model="item.transformPsName"
                filterable
                popper-class="font-family-options-wrap mf-dialog"
                @change="psName => onModelFontFamilyChange(item.fontName, psName)"
              >
                <el-option
                  v-for="font in fontList"
                  :key="font.id"
                  :label="font.fontFamily"
                  :value="font.psName"
                >
                  <img :src="font.preview" height="18"/>
                </el-option>
                <div slot="empty"></div>
                <div class="mf-link-wrap">
                  <a href="/#/admin/projFont" target="_blank">去上传字体 &rarr;</a>
                </div>
              </el-select>
            </div>
          </li>
        </ul>
      </div>
      <div class="missing-font-wrap-footer">
        <el-button type="primary" @click="handleConfirm">确认</el-button>
      </div>
    </div>
    <slot slot="reference"></slot>
  </el-popover>
</template>
<script>
// import fontUploader from '../../template/font/font-uploader'
import fontService from '@/request/service/font-service'
import util from '@/util.js'
let fontLocationObj = null

export default {
  // components: { fontUploader },
  props: {
    value: { type: Boolean, default: false },
    data: Array,
    tplProjectId: String
  },
  data () {
    return {
      loading: false,
      dataList: [],
    }
  },
  computed: {
    fontList () {
      return this.$store.state.app.projectFontList
    },
    dialogValue: {
      get () {
        return this.value
      },
      set (v) {
        this.$emit('input', v)
      }
    }
  },
  watch: {
    dialogValue: {
      handler (v) {
        if (v) {
          this.init()
        }
      },
      immediate: true
    }
  },
  methods: {
    init () {
      fontLocationObj = Object.create(null)
      let dataSet = new Set()
      this.data.forEach(item => {
        if (item.missingFont) {
          !(item.beforeFontFamily) && (item.beforeFontFamily = item.fontFamily)
          dataSet.add(item.beforeFontFamily || item.fontFamily)
        } else {
          item.beforeFontFamily = null
        }
      })
      const missingFontSet = [...dataSet].map(fontName => {
        return {
          id: util.getUUID(),
          fontName,
          name: '',
          fontFamily: fontName,
          alias: fontName,
          transformPsName: ''
        }
      })
      fontService.getRecommendFonts({
        names: missingFontSet.map(item => item.fontName).join(','),
        projectId: this.tplProjectId
      }).then(data => {
        missingFontSet.forEach(item => {
          const font = data.find(font => font.missingFont === item.fontName)
          if (font) {
            item.transformPsName = font.recPsName
          }
        })
        // console.log('missingFontSet', missingFontSet)
        this.dataList = missingFontSet
        this.initFonts()
      })
      // =======================================为了定位去做的列表==========================================================
      this.data.forEach(item => {
        // console.log(123, missingFontSet.map(font => font.fontName), item.fontFamily)
        const missingFontNameSet = missingFontSet.map(font => font.fontName)
        if (item.missingFont && missingFontNameSet.length > 0 && missingFontNameSet.includes(item.beforeFontFamily || item.fontFamily)) {
          !fontLocationObj[item.beforeFontFamily || item.fontFamily] && (fontLocationObj[item.beforeFontFamily || item.fontFamily] = { index: 0, list: [] })
          fontLocationObj[item.beforeFontFamily || item.fontFamily].list.push(item)
        }
      })
      // console.log('fontLocation123', fontLocationObj)
    },
    getRecommendFontsUrl (fontName) {
      // console.log(fontName)
      const fontUrl = this.fontList.find(font => font.psName === fontName).url
      // console.log(fontName, fontUrl)
      util.downloadFont(fontName, fontUrl)
    },
    handleFocusLayer (fontName) {
      // console.log(fontLocationObj)
      this.$emit('onItemClick', fontLocationObj[fontName].list[fontLocationObj[fontName].index])
      fontLocationObj[fontName].index === fontLocationObj[fontName].list.length - 1 ? fontLocationObj[fontName].index = 0 : fontLocationObj[fontName].index++
    },
    onCancel () {
      this.dialogValue = false
      // this.$emit('input', false)
    },
    setCurrentFont (item) {
      this.currentFont = item
    },
    onSuccess (data) {
      this.dataList = this.dataList.filter(item => {
        return item.fontFamily !== data.name
      })
      this.replaceMissingFontFlag(data.name)
      if (this.dataList.length === 0) {
        this.dialogValue = false
      }
      this.$store.dispatch('app/queryFontList', {
        projectId: this.tplProjectId
      })
    },
    handleConfirm () {
      this.dataList.forEach(item => {
        console.log(item.fontName, item.transformPsName)
        this.replaceMissingFontFlag(item.fontName, item.transformPsName)
      })
      this.dialogValue = false
    },
    onModelFontFamilyChange (oFontName, nFontName) {
      // console.log(123, oFontName, nFontName, this.data)
      const fontUrl = this.fontList.find(font => font.psName === nFontName).url
      util.downloadFont(nFontName, fontUrl).then(() => {
        this.data.forEach(originItem => {
          if (originItem.beforeFontFamily === oFontName) {
            originItem.fontFamily = nFontName
            originItem.missingFont = false
          }
        })
      })
    },
    initFonts () {
      this.dataList.forEach(item => {
        this.data.forEach(originItem => {
          if (originItem.missingFont) {
            originItem.fontFamily = item.transformPsName
            this.getRecommendFontsUrl(item.transformPsName)
          }
        })
      })
    },
    replaceMissingFontFlag (fontName, psName) {
      this.data.forEach(originItem => {
        if (originItem.missingFont && originItem.beforeFontFamily === fontName) {
          originItem.fontFamily = psName
          originItem.beforeFontFamily = null
          originItem.missingFont = false
        }
      })
    }
  }
}
</script>
<style lang="scss">
@import 'missing-font-modal';
</style>
